module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/nightwear-d3f43aba9fe502bca56183a3f834e7e0.svg";